// Libraries
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TimeKeeper from 'react-timekeeper';

import './timePicker.scss';

const StyledErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
`;

const TimePicker = ({
    startTime,
    endTime,
    setStarTime,
    setEndTime,
    hour24Mode,
    input,
    onTimeChange,
    meta,
}) => {
    // End Start Time States
    const [showStartTime, setShowStartTime] = useState(false);
    const [showEndTime, setShowEndTime] = useState(false);

    const handleStartTimeChange = newTime => {
        const time = hour24Mode ? newTime.formatted24 : newTime.formatted12;
        setStarTime(time);
        const data = {
            startTime: time,
            endTime,
        };
        if (input) {
            input.onChange(data);
        } else {
            onTimeChange(data);
        }
    };

    const handleEndTimeChange = newTime => {
        const time = hour24Mode ? newTime.formatted24 : newTime.formatted12;
        setEndTime(time);
        const data = {
            startTime,
            endTime: time,
        };
        if (input) {
            input.onChange(data);
        } else {
            onTimeChange(data);
        }
    };

    return (
        <>
            <div className="time-picker">
                <div className="startTime-picker time-input-wrap">
                    {showStartTime && (
                        <>
                            <div
                                className="backdrop"
                                onClick={() => setShowStartTime(false)}
                            />
                            <TimeKeeper
                                time={startTime}
                                hour24Mode={hour24Mode}
                                onChange={handleStartTimeChange}
                                onDoneClick={() => setShowStartTime(false)}
                            />
                        </>
                    )}
                    {startTime ? (
                        <span
                            className="timepicker-input"
                            onClick={() => setShowStartTime(true)}
                        >
                            {startTime}
                        </span>
                    ) : (
                        <span
                            className="timepicker-placeholder"
                            onClick={() => setShowStartTime(true)}
                        >
                            Start Time
                        </span>
                    )}
                </div>
                <div className="endTime-picker time-input-wrap">
                    {showEndTime && (
                        <>
                            <div
                                className="backdrop"
                                onClick={() => setShowEndTime(false)}
                            />
                            <TimeKeeper
                                time={endTime}
                                hour24Mode={hour24Mode}
                                onChange={handleEndTimeChange}
                                onDoneClick={() => setShowEndTime(false)}
                            />
                        </>
                    )}
                    {endTime ? (
                        <span
                            className="timepicker-input"
                            onClick={() => setShowEndTime(true)}
                        >
                            {endTime}
                        </span>
                    ) : (
                        <span
                            className="timepicker-placeholder"
                            onClick={() => setShowEndTime(true)}
                        >
                            End Time
                        </span>
                    )}
                </div>
            </div>
            {meta && meta.touched && meta.error && (
                <StyledErrorWrapper className="error-message">
                    {meta.error}
                </StyledErrorWrapper>
            )}
        </>
    );
};

TimePicker.propTypes = {
    input: PropTypes.object,
    onTimeChange: PropTypes.func,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    setStarTime: PropTypes.func,
    setEndTime: PropTypes.func,
    hour24Mode: PropTypes.bool,
    meta: PropTypes.object,
};

export default TimePicker;
